import Lottie from "lottie-react";
import successAnimation from "../assets/animations/Success.json";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { resetStatus } from "../store/slices/userSlice";

const SuccessPage = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  useEffect(() => {
       dispatch(resetStatus());
   }, [dispatch]);

  // 🔹 priority: location.state → props → default
  const {
    title = location.state?.title || "Great job!",
    message =
      location.state?.message || "Action completed successfully.",
    buttonText =
      location.state?.buttonText || "Back To Dashboard",
    redirectTo = location.state?.redirectTo || "/",
    redirectState = location.state?.redirectState || null,
    animation = successAnimation,
  } = props;

  // safety: direct URL access
  if (!location.state && !props.title) {
    navigate("/", { replace: true });
    return null;
  }

  return (
    <div className="successfuly mb_80 mt_60">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 text-center m-auto d-flex justify-content-center align-items-center flex-column">
            <Lottie
              animationData={animation}
              loop={false}
              style={{ width: 200, height: 200 }}
            />

            <h2>{title}</h2>

            <p className="my_20">{message}</p>

            <Link
              to={redirectTo}
              state={redirectState}   // 👈 params pass ho rahe
              className="btn btn_primary"
            >
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;